export default __webpack_public_path__ + "static/media/gallery_07.b13b18c8.jpg";